import { ChangeDetectorRef, Component } from '@angular/core';
import { Router } from '@angular/router';
import { NbIconLibraries, NbSidebarService } from '@nebular/theme';
import { LayoutStateService } from '../layout-state.service';
import { GenericValidationsService } from 'src/app/Service/generic-validations.service';
import { environment } from 'src/environments/environment';
import { APP_MENU, UserRole } from 'src/Core/Constant';
import { TranslationService } from 'src/app/Service/translation.service';

@Component({
  selector: 'app-user-header-component',
  templateUrl: './user-header-component.component.html',
  styleUrls: ['./user-header-component.component.scss']
})
export class UserHeaderComponentComponent {

  isJsonShow = environment.isJsonShow;
  headerTitle = '';
  subHeaderTitle = '';
  user :any
  dropdownOpen = false;
  filteredMenu: any[] = [];
  permission :any
  menu = APP_MENU 

  // Dummy data for the company header
  companyName = this.isJsonShow ? 'Kirloskar Brothers Limited' : 'Gurudev Siddha Peeth';
  companyGroup = this.isJsonShow ? 'A Kirloskar Group Company' : 'Siddha Yoga Sangham Of India';


   
  constructor(private validationService : GenericValidationsService , private translationService: TranslationService,private cd:ChangeDetectorRef, private headerService: GenericValidationsService, private iconLibraries: NbIconLibraries, private sidebarService: NbSidebarService, private layoutState: LayoutStateService, private router: Router) {
    this.iconLibraries.registerSvgPack('myicons', {
      'profile': '<svg width="19" height="19" viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M11.1741 1.09344C10.4211 0.788189 9.57892 0.788189 8.82592 1.09344L7.00048 1.83348L14.994 4.94206L17.8059 3.85563C17.6927 3.76168 17.5641 3.68397 17.4229 3.62675L11.1741 1.09344ZM18.3333 4.99192L10.6248 7.97025V17.0728C10.8113 17.0347 10.9953 16.9795 11.1741 16.907L17.4229 14.3737C17.9732 14.1506 18.3333 13.616 18.3333 13.0222V4.99192ZM9.37483 7.97025V16.3125L7.85443 14.7921C8.16093 14.1772 8.33333 13.4838 8.33333 12.7501C8.33333 10.2187 6.28131 8.16675 3.75 8.16675C2.99982 8.16675 2.29173 8.347 1.66667 8.6665V4.99206L9.37483 7.97025ZM2.19394 3.85572L9.99983 6.87163L13.264 5.61048L5.31195 2.51802L2.5771 3.62675C2.4359 3.68399 2.30723 3.76173 2.19394 3.85572ZM3.75 16.5001C4.55989 16.5001 5.30983 16.2433 5.92283 15.8068L8.09973 17.9837C8.34383 18.2277 8.7395 18.2277 8.98358 17.9837C9.22767 17.7396 9.22767 17.3439 8.98358 17.0998L6.80672 14.9229C7.24326 14.3099 7.5 13.56 7.5 12.7501C7.5 10.679 5.82107 9.00008 3.75 9.00008C1.67893 9.00008 0 10.679 0 12.7501C0 14.8212 1.67893 16.5001 3.75 16.5001ZM3.75 15.2501C2.36929 15.2501 1.25 14.1308 1.25 12.7501C1.25 11.3693 2.36929 10.2501 3.75 10.2501C5.13071 10.2501 6.25 11.3693 6.25 12.7501C6.25 14.1308 5.13071 15.2501 3.75 15.2501Z" fill="#ADB5BD"/></svg>',
      'role': '<svg width="19" height="19" viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M8.16862 13.5833C8.16862 12.5092 8.48128 11.5081 9.02053 10.666H2.54593C1.51092 10.666 0.671875 11.5051 0.671875 12.5401V13.3067C0.671875 13.7834 0.820542 14.2483 1.09718 14.6366C2.38231 16.4402 4.48478 17.3337 7.33562 17.3337C8.11128 17.3337 8.83162 17.2675 9.49528 17.1348C8.66887 16.184 8.16862 14.9421 8.16862 13.5833ZM7.33562 0.669922C9.63678 0.669922 11.5023 2.5354 11.5023 4.83659C11.5023 7.13777 9.63678 9.00325 7.33562 9.00325C5.0344 9.00325 3.16892 7.13777 3.16892 4.83659C3.16892 2.5354 5.0344 0.669922 7.33562 0.669922ZM18.1686 13.5833C18.1686 16.1147 16.1166 18.1667 13.5853 18.1667C11.054 18.1667 9.00195 16.1147 9.00195 13.5833C9.00195 11.052 11.054 9 13.5853 9C16.1166 9 18.1686 11.052 18.1686 13.5833ZM12.63 11.7947C12.7926 11.6319 12.7926 11.3681 12.63 11.2053C12.4672 11.0427 12.2034 11.0427 12.0406 11.2053L10.7906 12.4553C10.628 12.6181 10.628 12.8819 10.7906 13.0447L12.0406 14.2947C12.2034 14.4573 12.4672 14.4573 12.63 14.2947C12.7926 14.1319 12.7926 13.8681 12.63 13.7053L12.0912 13.1667H13.7936C14.8291 13.1667 15.6686 14.0062 15.6686 15.0417V15.25C15.6686 15.4801 15.8552 15.6667 16.0853 15.6667C16.3154 15.6667 16.502 15.4801 16.502 15.25V15.0417C16.502 13.5459 15.2894 12.3333 13.7936 12.3333H12.0912L12.63 11.7947Z" fill="#ADB5BD"/></svg>',
      'password': '<svg width="16" height="18" viewBox="0 0 16 18" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M10.7107 0.666748C11.6759 0.666748 12.4708 1.39611 12.5743 2.33378L13.6307 2.33341C14.3959 2.33341 15.0234 2.92267 15.0842 3.67214L15.089 3.79175V6.29175C15.089 7.73591 13.9587 8.91608 12.5344 8.99583L12.3592 9.00066C11.8027 10.7425 10.2772 12.0513 8.4166 12.2932L8.4161 13.5834H9.87735C11.3215 13.5834 12.5017 14.7138 12.5814 16.1381L12.5857 16.2917V16.7084C12.5857 17.0248 12.3505 17.2863 12.0455 17.3277L11.9607 17.3334H3.62482C3.3084 17.3334 3.04691 17.0982 3.00553 16.7932L2.99982 16.7084V16.2917C2.99982 14.8476 4.1302 13.6674 5.55447 13.5877L5.70815 13.5834H7.1661L7.16635 12.2928C5.30698 12.0502 3.78258 10.7417 3.22631 9.00066L3.20443 9.00008C1.70866 9.00008 0.496094 7.7875 0.496094 6.29175V3.79175C0.496094 2.98633 1.14902 2.33341 1.95443 2.33341L3.01122 2.33378C3.11469 1.39611 3.90958 0.666748 4.87482 0.666748H10.7107ZM13.6307 3.58341H12.5857V7.73583C13.2524 7.642 13.7744 7.09744 13.8334 6.42021L13.839 6.29175V3.79175C13.839 3.69312 13.7705 3.61051 13.6785 3.58891L13.6307 3.58341ZM2.99982 3.58341H1.95443C1.83937 3.58341 1.74609 3.67669 1.74609 3.79175V6.29175C1.74609 7.02772 2.29128 7.63633 2.99982 7.73583V3.58341Z" fill="#ADB5BD"/></svg>',
      'grievance': '<svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M10.618 3.16656L14.8355 7.38408L6.55366 15.6658C6.32293 15.8965 6.03598 16.0631 5.72118 16.1489L1.45811 17.3116C0.991542 17.4388 0.563433 17.0107 0.690683 16.5442L1.85333 12.2811C1.93919 11.9663 2.10572 11.6793 2.33644 11.4486L10.618 3.16656ZM4.43949 8.16658L3.18949 9.41658L1.29366 9.41692C0.948475 9.41692 0.668658 9.13708 0.668658 8.79192C0.668658 8.44675 0.948475 8.16692 1.29366 8.16692L4.43949 8.16658ZM16.3998 1.35466L16.5273 1.47498L16.6476 1.60245C17.6903 2.77348 17.6502 4.56923 16.5273 5.69219L15.7188 6.4999L11.5013 2.28323L12.3101 1.47498C13.4331 0.352017 15.2288 0.311909 16.3998 1.35466ZM7.7728 4.83323L6.52283 6.08323L1.29366 6.08358C0.948475 6.08358 0.668658 5.80377 0.668658 5.45858C0.668658 5.11341 0.948475 4.83358 1.29366 4.83358L7.7728 4.83323ZM11.1061 1.4999L9.85613 2.74989L1.29366 2.75025C0.948475 2.75025 0.668658 2.47043 0.668658 2.12525C0.668658 1.78008 0.948475 1.50025 1.29366 1.50025L11.1061 1.4999Z" fill="#ADB5BD"/></svg>',
      'logout': '<svg width="18" height="14" viewBox="0 0 18 14" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M9.00033 0.628082V5.74958L9.00074 6.17042L15.202 6.16958L13.7667 4.73314C13.5448 4.51121 13.5247 4.16399 13.7062 3.91934L13.7668 3.84926C13.9887 3.62741 14.3359 3.60729 14.5806 3.78888L14.6507 3.84941L17.1478 6.34741C17.3695 6.56916 17.3898 6.916 17.2087 7.16066L17.1482 7.23075L14.6511 9.73358C14.4073 9.978 14.0116 9.97841 13.7672 9.73466C13.5451 9.513 13.5245 9.16583 13.7057 8.92092L13.7662 8.85075L15.1937 7.41958L9.00074 7.42042L9.00033 13.0412C9.00033 13.4299 8.64933 13.7243 8.26666 13.6567L1.18328 12.4057C0.884667 12.3529 0.666992 12.0934 0.666992 11.7902V1.79127C0.666992 1.48518 0.888667 1.22413 1.19072 1.17453L8.27408 0.0113401C8.65458 -0.0511432 9.00033 0.242474 9.00033 0.628082ZM6.08545 6.58292C5.62423 6.58292 5.25033 6.95683 5.25033 7.41808C5.25033 7.87933 5.62423 8.25317 6.08545 8.25317C6.54668 8.25317 6.92058 7.87933 6.92058 7.41808C6.92058 6.95683 6.54668 6.58292 6.08545 6.58292ZM9.83366 12.4173L10.4713 12.4175L10.5562 12.4117C10.8616 12.3702 11.0968 12.1082 11.0963 11.7914L11.0903 8.24958H9.83366V12.4173ZM9.83533 5.33294L9.83366 4.27072V1.16626L10.4547 1.16627C10.7707 1.16627 11.0321 1.40087 11.0739 1.70553L11.0797 1.79024L11.0853 5.33294H9.83533Z" fill="#ADB5BD"/></svg>'

    });
  }



  ngOnInit(): void {
    this.headerService.headerTitle$.subscribe(title => this.headerTitle = title);
    this.headerService.subHeaderTitle$.subscribe(sub => this.subHeaderTitle = sub);
    const userDataString = JSON.parse(localStorage.getItem('userData') || '{}') || {};
    this.permission = userDataString;
    const selectedRole = localStorage.getItem('selectedRole');
    const roleScopedPermission = (() => {
      if (!selectedRole) return this.permission;
      const rolePerm = (this.permission?.RoleMenuPermissions || []).find((p: any) => p.role_key === selectedRole);
      if (!rolePerm) return this.permission;
      return {
        ...this.permission,
        RoleMenuPermissions: [rolePerm]
      };
    })();
    this.filteredMenu = this.validationService.filterMenuBasedOnPermissions(
      this.menu,
      roleScopedPermission
    );
    
    // Initialize selected language from localStorage or use default
    const storedLanguage = localStorage.getItem('selectedLanguage');
    console.log('Stored language from localStorage:', storedLanguage);
    this.selectedLanguage = storedLanguage || 'en';
    console.log('Selected language set to:', this.selectedLanguage);
    // Set the language in translation service to ensure consistency
    this.translationService.setLanguage(this.selectedLanguage);

    // Load roles from userData in localStorage
    const userDataRaw = localStorage.getItem('userData');
    let availableRoles: string[] = [];
    try {
      const userData = userDataRaw ? JSON.parse(userDataRaw) : {};
      availableRoles = Array.isArray(userData?.Roles) ? userData.Roles : [];
    } catch {
      availableRoles = [];
    }
    this.availableRoles = availableRoles;

    // Initialize selected role from localStorage or fallback to first role if available
    const storedRole = localStorage.getItem('selectedRole');
    this.selectedRole = storedRole || (this.availableRoles.length > 0 ? this.availableRoles[0] : 'Applicant');
    localStorage.setItem('selectedRole', this.selectedRole);
  }

  toggleDropdown() {

    this.dropdownOpen = !this.dropdownOpen;

    const userDataString = JSON.parse(localStorage.getItem('userData') || '{}') || {};
    this.permission = userDataString;
    const selectedRole = localStorage.getItem('selectedRole');
    const roleScopedPermission = (() => {
      if (!selectedRole) return this.permission;
      const rolePerm = (this.permission?.RoleMenuPermissions || []).find((p: any) => p.role_key === selectedRole);
      if (!rolePerm) return this.permission;
      return {
        ...this.permission,
        RoleMenuPermissions: [rolePerm]
      };
    })();

      // ✅ call service method
      this.filteredMenu = this.validationService.filterMenuBasedOnPermissions(
        this.menu,
        roleScopedPermission
      );


  }

  toggleMenuSidebar(): void {
    this.sidebarService.toggle(true, 'menu-sidebar');
    this.layoutState.toggleSidebar();
  }


  get truncatedFullName(): string {
    return this.user.fullName.length > 10 ? this.user.fullName.substring(0, 10) + '...' : this.user.fullName;
  }

  selectedLanguage: string = ''; // Will be initialized in ngOnInit

  // Handle language change
  onLanguageChange(): void {
    console.log('Language changed to:', this.selectedLanguage);
    this.translationService.setLanguage(this.selectedLanguage);
    console.log('Language saved to localStorage:', localStorage.getItem('selectedLanguage'));
    // Force change detection to update the UI
    // The translations will be updated automatically through the getTranslation method
  }



  // Role selector state
  availableRoles: string[] = [];
  selectedRole: string = '';

  // Handle role change (replicates applicant layout behavior)
  onRoleChange(): void {
    localStorage.setItem('selectedRole', this.selectedRole);

    // Recompute filtered menu for the new role
    const userDataString = JSON.parse(localStorage.getItem('userData') || '{}') || {};
    this.permission = userDataString;
    const roleScopedPermission = (() => {
      if (!this.selectedRole) return this.permission;
      const rolePerm = (this.permission?.RoleMenuPermissions || []).find((p: any) => p.role_key === this.selectedRole);
      if (!rolePerm) return this.permission;
      return {
        ...this.permission,
        RoleMenuPermissions: [rolePerm]
      };
    })();
    this.filteredMenu = this.validationService.filterMenuBasedOnPermissions(this.menu, roleScopedPermission);

    // Navigate based on role
    switch (this.selectedRole) {
      case 'SuperAdmin':
        this.router.navigate(['/admin']);
        break;
      case 'COC':
        this.router.navigate(['/coc']);
        break;
      case 'GAO':
        this.router.navigate(['/gao']);
        break;
      case 'APP':
        this.router.navigate(['/app']);
        break;
      case 'SevaCenter':
        this.router.navigate(['/seva-center']);
        break;
      case 'FirstAid':
        this.router.navigate(['/firstAid']);
        break;
      case 'HR':
        this.router.navigate(['/hr']);
        break;
      case 'Applicant':
      default:
        this.router.navigate(['/applicant']);
        break;
    }
  }
}
